"use client"

/** Shared optional-preferences field. Storybook: Catalog → Search → Analysis instructions field. */
import { Label, Textarea, getSmartAnalysisIntroCopy } from '@yeshuman/sdk'
import type { SmartAnalysisDirection, SmartAnalysisIntroMode } from '@yeshuman/sdk'
import type { ReactNode } from 'react'

export type SmartAnalysisInstructionsFieldProps = {
  id: string
  direction: SmartAnalysisDirection
  mode?: SmartAnalysisIntroMode
  jobTitle?: string
  jobScoped?: boolean
  emptyActiveApplicants?: boolean
  value: string
  onChange: (value: string) => void
  leadingSlot?: ReactNode
}

export function SmartAnalysisInstructionsField({
  id,
  direction,
  mode = 'idle',
  jobTitle,
  jobScoped,
  emptyActiveApplicants,
  value,
  onChange,
  leadingSlot,
}: SmartAnalysisInstructionsFieldProps) {
  const copy = getSmartAnalysisIntroCopy({
    direction,
    mode,
    jobTitle,
    jobScoped,
    emptyActiveApplicants,
  })

  return (
    <>
      {leadingSlot}
      <div className="space-y-2">
        <Label htmlFor={id}>{copy.preferencesLabel}</Label>
        <Textarea
          id={id}
          placeholder={copy.preferencesPlaceholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="min-h-[80px]"
        />
      </div>
    </>
  )
}
